import { Link } from 'react-router-dom';

export default function Footer() {
  const handleNavigation = (path: string) => {
    if (path.startsWith('/')) {
      window.REACT_APP_NAVIGATE(path);
    } else {
      document.getElementById(path)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative bg-gradient-to-br from-teal-500 via-teal-600 to-teal-700 text-white py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Logo & Description */}
          <div className="md:col-span-1">
            <h3 className="text-3xl font-serif font-bold mb-4">Ke'iki</h3>
            <p className="text-white/90 text-sm leading-relaxed">
              Restaurant local à Moorea. Cuisine généreuse, terrasse agréable, ambiance conviviale.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Navigation</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button
                  onClick={() => handleNavigation('/')}
                  className="text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Accueil
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigation('/a-propos')}
                  className="text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  À propos
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigation('menu')}
                  className="text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Menu
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigation('/evenements')}
                  className="text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Événements
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigation('contact')}
                  className="text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Horaires */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Horaires</h4>
            <ul className="space-y-2 text-sm text-white/90">
              <li>Lundi - Dimanche</li>
              <li className="font-medium text-white">11h00 - 22h00</li>
              <li className="mt-4">Concerts de ukulélé</li>
              <li className="font-medium text-white">18h00 - 20h00</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-lg"></i>
                <a href="tel:+68987252525" className="text-white/90 hover:text-white transition-colors">
                  +689 87 25 25 25
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-lg"></i>
                <a href="mailto:ke.iki@hotmail.com" className="text-white/90 hover:text-white transition-colors">
                  ke.iki@hotmail.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-lg mt-0.5"></i>
                <span className="text-white/90">
                  Moorea, Polynésie française
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-white/80">
          <p>© 2024 Ke'iki Moorea. Tous droits réservés.</p>
          <div className="flex items-center gap-4">
            <span className="text-xl">🌈</span>
            <span>LGBTQ+ friendly</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
